import * as C from 'actions/constants';

export const blankState = {
  data: [],
  loading: false,
};

const PhotoTagsReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_PHOTO_TAGS: {
      return { ...state, loading: true };
    }
    case C.LOAD_PHOTO_TAGS_SUCCESS: {
      const { data } = action;
      return { ...state, data, loading: false };
    }
    case C.LOAD_PHOTO_TAGS_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default PhotoTagsReducer;
